module.exports = __webpack_public_path__ + "img/star.bb48f030.svg";